import ErrorMessage from '@components/error-message/ErrorMessage';
import { TextDisplay } from '@components/text-display/TextDisplay';
import { Radio } from '@mis/sushi-tailwind-react';
import { RadioOption } from '@model/radio';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export type RadioGroupProps = React.ComponentProps<typeof Radio> & {
  items: RadioOption[];
  ['data-testid']?: string;
  viewOnly?: boolean;
  status?: 'error';
  message?: string;
};

const RadioGroupComponent: React.FC<RadioGroupProps> = ({ name, onChange, message, className, status, viewOnly, items, ...props }) => {
  const { t } = useTranslation('error');
  if (viewOnly) {
    const displayValue = items.find((i) => i.value === props.value)?.label;
    return (
      <div className="w-1/2 pr-2">
        <TextDisplay data-testid={name} type={name || 'radio-display'} value={displayValue} />
      </div>
    );
  }
  return (
    <div data-testid={props['data-testid'] || name} className="flex flex-col">
      <div className="flex min-h-[32px] flex-row gap-2">
        {items.map(({ label, value }) => {
          return (
            <div key={`${value}`} className={classNames({ 'text-gray-100': props.disabled }, className)}>
              <Radio
                {...props}
                onChange={onChange}
                value={value}
                className={classNames({ 'border-danger-900': status === 'error' })}
                data-testid={`radio-${name}-${value}`}
                checked={String(props.value) === String(value)}
              >
                {label}
              </Radio>
            </div>
          );
        })}
      </div>
      <ErrorMessage status={status} message={t(message as string)} className="text-xs text-danger-900" />
    </div>
  );
};

export default RadioGroupComponent;
